import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/assets/images/logo-para-fondo-obscuro.png"
                alt="i3d.Ninja Logo"
                className="h-12"
              />
            </div>
            <p className="text-sm">{t('common.footer.description')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('common.footer.services')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios/impresion-fdm" className="hover:text-blue-400 transition">
                  {t('common.navigation.fdm')}
                </Link>
              </li>
              <li>
                <Link to="/servicios/impresion-sla" className="hover:text-blue-400 transition">
                  {t('common.navigation.sla')}
                </Link>
              </li>
              <li>
                <Link to="/servicios/diseno-cad" className="hover:text-blue-400 transition">
                  {t('common.navigation.cad')}
                </Link>
              </li>
              <li>
                <Link to="/calculadora" className="hover:text-blue-400 transition">
                  {t('common.navigation.calculator')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">
              {t('common.footer.resources')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="hover:text-blue-400 transition">
                  {t('common.navigation.blog')}
                </Link>
              </li>
              <li>
                <Link to="/comunidad" className="hover:text-blue-400 transition">
                  {t('common.navigation.community')}
                </Link>
              </li>
              <li>
                <Link to="/portafolio" className="hover:text-blue-400 transition">
                  {t('common.navigation.portfolio')}
                </Link>
              </li>
              <li>
                <Link to="/contacto#faq" className="hover:text-blue-400 transition">
                  {t('common.footer.faq')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('common.footer.contact')}</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-blue-500" />
                <span>contacto@i3d.Ninja</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-blue-500" />
                <span>+52 8182597917</span>
              </li>
              <li className="flex items-center space-x-2">
                <MessageCircle className="h-5 w-5 text-blue-500" />
                <a
                  href="https://wa.me/528182597917?text=Me%20interesan%20sus%20servicios"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-400 transition"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin className="h-5 w-5 text-blue-500" />
                <span>Monterrey, México</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm">
              {new Date().getFullYear()} i3d.Ninja. {t('common.footer.rights')}
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a
                href="https://www.facebook.com/i3d.ninja"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-400 transition"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://x.com/i3dNinja"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-400 transition"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/i3d.ninja/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-400 transition"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
